import { render, staticRenderFns } from "./noticeContentsPop.vue?vue&type=template&id=9685e2fe&scoped=true"
import script from "./noticeContentsPop.vue?vue&type=script&lang=js"
export * from "./noticeContentsPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9685e2fe",
  null
  
)

export default component.exports